var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeleteSvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.34996 14C4.07218 14 3.83607 13.9028 3.64163 13.7083C3.44718 13.5139 3.34996 13.2778 3.34996 13V3.5H2.66663V2.5H5.79996V2H10.2V2.5H13.3333V3.5H12.65V13C12.65 13.2667 12.55 13.5 12.35 13.7C12.15 13.9 11.9166 14 11.65 14H4.34996ZM11.65 3.5H4.34996V13H11.65V3.5ZM6.11663 11.5667H7.11663V4.91667H6.11663V11.5667ZM8.88329 11.5667H9.88329V4.91667H8.88329V11.5667ZM4.34996 3.5V13V3.5Z",
    fill: "#F44336"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteSvg);
export default __webpack_public_path__ + "static/media/delete_svg.ea37f7618d5587e0173402271de51e3e.svg";
export { ForwardRef as ReactComponent };